import { render, staticRenderFns } from "./OutboundOrderDetailDalog.vue?vue&type=template&id=71540b41&scoped=true&"
import script from "./OutboundOrderDetailDalog.vue?vue&type=script&lang=js&"
export * from "./OutboundOrderDetailDalog.vue?vue&type=script&lang=js&"
import style0 from "./OutboundOrderDetailDalog.vue?vue&type=style&index=0&id=71540b41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71540b41",
  null
  
)

export default component.exports